var map = {
	"./barcode-frame.svg": "a75e",
	"./check-circle.svg": "bad0",
	"./close-circle.svg": "1dbe",
	"./log-out.svg": "30fb",
	"./logo-a.svg": "5359",
	"./logo_apcom.svg": "a4ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";